import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  return (
    <nav className="navbar">
      <ul>
        <li><Link to="/smileguide/TermsAndConditions">Terms and Conditions</Link></li>
        <li><Link to="/smileguide/Cancellation&RefundPolicy">Cancellation & Refund Policy</Link></li>
        <li><Link to="/smileguide/Piracy&MisuseClause">Piracy & Misuse Clause</Link></li>
        <li><Link to="/smileguide/PrivacyPolicy">Privacy Policy</Link></li>
        <li><Link to="/smileguide/ShippingPolicy">Shipping Policy</Link></li>
      </ul>
    </nav>
  );
};

export default Navigation;
